// extracted by mini-css-extract-plugin
module.exports = {"consent":"Consent_consent__OXgdp","scale":"Consent_scale__xPMn6"};